export default __webpack_public_path__ + "static/ely-6-a25207516f4d472b4285ba2b500686f9.jpg";